import styled from 'styled-components';
import { breakpoint } from '../theme/breakpoint';

export const OuterWrapper = styled.div`
  background: ${({ theme, $greyBackground }) =>
    $greyBackground ? theme.palette.lightBackground : null};
  margin-bottom: ${({ $removeMarginBottom, theme }) =>
    $removeMarginBottom ? '0' : theme.spacing.xlarge};
`;

export const ColumnWrapper = styled.div`
  ${breakpoint.tablet`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  `}
`;

export const Column = styled.div`
  ${breakpoint.tablet`
    width: calc(33.33% - ${({ theme }) => theme.spacing.standard});
    margin-right: ${({ theme }) => theme.spacing.standard};
    &:last-of-type {
      margin-right: 0;
    }
  `}
`;

export const Title = styled.h2`
  margin-top: 0;
`;
